export const OPEN = 'MIGRATION_MODAL/OPEN';
export const CLOSE = 'MIGRATION_MODAL/CLOSE';

export const migrationOpenModal = ({ migrationData, migrationMessage, blockedDocuments, linkedDocuments }) => ({
  type: OPEN,
  migrationData,
  migrationMessage,
  blockedDocuments,
  linkedDocuments, // Keep for backward compatibility with old API responses
});

export const migrationCloseModal = () => ({ type: CLOSE });
